"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _Grid = _interopRequireWildcard(require("@instructure/ui-layout/lib/components/Grid"));

var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));

var _passthroughProps = require("@instructure/ui-utils/lib/react/passthroughProps");

var _FormFieldLayout = _interopRequireDefault(require("../FormFieldLayout"));

var _FormPropTypes = _interopRequireDefault(require("../../utils/FormPropTypes"));

var _theme = _interopRequireDefault(require("./theme"));

var _dec, _class, _class2, _temp;

var styles = {
  componentId: 'efIdg',
  template: function template(theme) {
    return "\n\n.efIdg_cLpc{border:".concat(theme.borderWidth || 'inherit', " ").concat(theme.borderStyle || 'inherit', " ").concat(theme.borderColor || 'inherit', ";border-radius:").concat(theme.borderRadius || 'inherit', ";display:block}\n\n.efIdg_cLpc.efIdg_fszt{border-color:").concat(theme.errorBorderColor || 'inherit', ";padding:").concat(theme.errorFieldsPadding || 'inherit', "}\n\n.efIdg_cLpc.efIdg_ywdX{cursor:not-allowed;opacity:0.6;pointer-events:none}");
  },
  'fields': 'efIdg_cLpc',
  'invalid': 'efIdg_fszt',
  'disabled': 'efIdg_ywdX'
};
var FormFieldGroup = (
/**
---
category: components
---
**/
_dec = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(FormFieldGroup, _Component);

  function FormFieldGroup() {
    (0, _classCallCheck2.default)(this, FormFieldGroup);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FormFieldGroup).apply(this, arguments));
  }

  (0, _createClass2.default)(FormFieldGroup, [{
    key: "renderColumns",
    value: function renderColumns() {
      return _react.Children.map(this.props.children, function (child, index) {
        return child ? _react.default.createElement(_Grid.GridCol, {
          width: child.props && child.props.width ? 'auto' : null,
          key: index
        }, child) : null;
      });
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      return _react.default.createElement(_Grid.default, {
        colSpacing: this.props.colSpacing,
        rowSpacing: this.props.rowSpacing,
        vAlign: this.props.vAlign,
        startAt: this.props.startAt || (this.props.layout === 'columns' ? 'medium' : null)
      }, _react.default.createElement(_Grid.GridRow, null, this.renderColumns()));
    }
  }, {
    key: "renderFields",
    value: function renderFields() {
      var _classnames;

      return _react.default.createElement("span", {
        key: "fields",
        className: (0, _classnames2.default)((_classnames = {}, (0, _defineProperty2.default)(_classnames, styles.fields, true), (0, _defineProperty2.default)(_classnames, styles.invalid, this.invalid), (0, _defineProperty2.default)(_classnames, styles.disabled, this.props.disabled), _classnames))
      }, this.renderChildren());
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_FormFieldLayout.default, Object.assign({}, (0, _passthroughProps.omitProps)(this.props, FormFieldGroup.propTypes), (0, _passthroughProps.pickProps)(this.props, _FormFieldLayout.default.propTypes), {
        vAlign: this.props.vAlign,
        layout: this.props.layout === 'inline' ? 'inline' : 'stacked',
        label: this.props.description,
        "aria-disabled": this.props.disabled ? 'true' : null,
        "aria-invalid": this.invalid ? 'true' : null
      }), this.renderFields());
    }
  }, {
    key: "invalid",
    get: function get() {
      return this.props.messages && this.props.messages.findIndex(function (message) {
        return message.type === 'error';
      }) >= 0;
    }
  }]);
  FormFieldGroup.displayName = "FormFieldGroup";
  return FormFieldGroup;
}(_react.Component), _class2.propTypes = {
  description: _propTypes.default.node.isRequired,

  /**
  * the element type to render as
  */
  as: _propTypes.default.elementType,

  /**
  * object with shape: `{
  * text: PropTypes.string,
  * type: PropTypes.oneOf(['error', 'hint', 'success', 'screenreader-only'])
  *   }`
  */
  messages: _propTypes.default.arrayOf(_FormPropTypes.default.message),

  /**
  * id for the form field messages
  */
  messagesId: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  children: _propTypes.default.node,
  layout: _propTypes.default.oneOf(['stacked', 'columns', 'inline']),
  rowSpacing: _propTypes.default.oneOf(['none', 'small', 'medium', 'large']),
  colSpacing: _propTypes.default.oneOf(['none', 'small', 'medium', 'large']),
  vAlign: _propTypes.default.oneOf(['top', 'middle', 'bottom']),
  startAt: _propTypes.default.oneOf(['small', 'medium', 'large', 'x-large', null])
}, _class2.defaultProps = {
  children: null,
  layout: void 0,
  startAt: void 0,
  messages: void 0,
  messagesId: void 0,
  as: 'fieldset',
  disabled: false,
  rowSpacing: 'medium',
  colSpacing: 'small',
  vAlign: 'middle'
}, _temp)) || _class);
exports.default = FormFieldGroup;